import Errors from "../../../../utils/Errors";
import {basicContext} from "../../../../utils/contextUtils";

export const entity = {
    name: 'OrganizationalAxis',
    facets: [
        {name: 'codeName', nameOptional: false, uniqueName: true, uniqueCode: true},
    ],
    fields: [
        {path: 'includeInFunctionScope', type: 'boolean'},
        {path: 'projectBreakdownAxe', type: 'boolean'},
        {path: 'workflowEnabledAxe', type: 'boolean'}
    ],
    uniqueProcess: function ( ID, workflowEnabledAxe, includeInFunctionScope, projectBreakdownAxe, context, callback) {
        if (workflowEnabledAxe && !includeInFunctionScope){
            return callback(new Errors.ValidationError(context.tc("workflowAxisMustBeFunctionAxisError")))
        }
        if (projectBreakdownAxe){
            return global.app.SE.OrganizationalAxis.find({
                ...basicContext(context),
                fieldPath: [],
                query: {"_id": {$ne: new global.ObjectID(ID)}, "projectBreakdownAxe": true}
            }, (e, axes) => {
                if (!!axes.length) return callback(new Errors.ValidationError(context.tc("uniqueProjectBreakdownAxisError")))
                return callback()
            })
        }
        callback()
    },
    validateSave: function (newObject, oldObject, context, callback) {
        this.uniqueProcess( newObject.id, newObject.workflowEnabledAxe, newObject.includeInFunctionScope, newObject.projectBreakdownAxe, context, callback)
    },
}

export const module_ = {
    object: 'OrganizationalAxis',
    category: {
        path: 'referencial',
        icon: 'briefcase'
    },
    defaultSortBy: 'name',
    defaultSortDirection: 'ASC',  //DESC
    viewMap: {
        dt: [ 'code',
            {path: 'name', type: 'translatedText'},
            {path: 'includeInFunctionScope', tKey: 'functionAxis'},
            {path: 'projectBreakdownAxe', tKey: 'projectVentilationPreValidation'},
            {path: 'workflowEnabledAxe', tKey: 'workflowOrganizationalAxis'}
        ],
        form: [
            {path: 'code', editable: false},
            {path: 'name', type: 'textarea', placeholder: 'fr:: nom en français\nen:: name in english\n...'},
            {path: 'includeInFunctionScope',tKey: 'functionAxis'},
            {path: 'projectBreakdownAxe', tKey: 'projectVentilationPreValidation'},
            {path: 'workflowEnabledAxe', tKey: 'workflowOrganizationalAxis'},
        ],
    },
}
